import React from 'react'

export const Footer = () => {
  return (
    <footer>

        <div>
            <h1>CompanySite</h1>
            <p>@ alll right reserved 2023</p>
        </div>

        <div>
            <h5>Follow us</h5>
            <div>
                <a href="https://github.com/Muhammad-Faizan-Tariq" target={"blank"}>Github</a>
                <a href="https://www.linkedin.com/in/faizanrealpk" target={"blank"}>LinkedIn</a>
            </div>
        </div>

    </footer>
  )
}
